import { FormattedMessage } from "react-intl";

const IncidentProblemManagement = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.incidentProblemManagement.content.body"
                    defaultMessage="Identify affected services, track related issues, and escalate to the correct team for resolution. Address root causes with PIRs."
                />
            </p>
        </div>
    );
};

export default IncidentProblemManagement;
